document.addEventListener("DOMContentLoaded", function(event) {
    window.setTimeout(() => {
        const ctasParallax = document.querySelectorAll('.cta-parallax .cta-large--with-bg__wrapper > div');
        if(ctasParallax.length > 0) {
            let pictureBlock = document.querySelector('.alterning-dual-col__image-ctn');
            let pictureBlockHeight = 0;
            let isPictureBlockTooSmall = window.innerWidth * 0.53;
            if(!pictureBlock){
                pictureBlockHeight = 'calc(100vw * 0.53)';
            } else if(pictureBlock.offsetHeight > isPictureBlockTooSmall) {
            } else {
            }
            const windowWidth = window.innerWidth;
            for(let x = 0; ctasParallax.length > x; x++) {
                if(pictureBlockHeight !== 0 && windowWidth < 1200) {
                }
            }
            window.addEventListener('resize', () => {
                let pictureBlock = document.querySelector('.alterning-dual-col__image-ctn');
                let pictureBlockHeight = 0;
                let isPictureBlockTooSmall = window.innerWidth * 0.53;

                const windowWidth = window.innerWidth;
                window.setTimeout(() => {
                    if(pictureBlock) {
                        for(let x = 0; ctasParallax.length > x; x++) {
                            if(pictureBlockHeight !== 0 && windowWidth < 1200) {
                            }
                            else if(windowWidth >= 1200) {
                            }
                        }
                    }
                }, 10)
            });
        }
    }, 1000)
});
